const TableOfContents = {
    toggle_toc() {
        $('.transform').toggleClass('transform-active');
    }
};

export default TableOfContents;




